import { useEffect, useState } from "react";
import MyTable from "../../Components/MyTable";
import Mytitle from "../../Components/Mytitle";
import MyInput from "../../Components/Myinput";
import MyButton from "../../Components/MyButton";
import { toast } from "react-toastify";
// import { toast } from "react-toastify";

function Cash() {
  const [filters, setFilters] = useState({
    from: "",
    to: "",
    cash_type: "",
  });
  const [appliedFilters, setAppliedFilters] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [cashBalance, setCashBalance] = useState(null);

  const columns = [
    { header: "التاريخ", accessor: "date" },
    // {
    //   header: "النوع",
    //   accessor: (row) =>
    //     row.type === "invoice_service"
    //       ? "فاتورة خدمات"
    //       : row.type === "send_money_invoice"
    //       ? "سند صرف"
    //       : row.type === "receive_money_invoice"
    //       ? "سند قبض"
    //       : row.type === "owner_withdrawl"
    //       ? "مسحوبات المالك"
    //       : row.type === "salary"
    //       ? "الرواتب"
    //       : row.type === "cash_transfer"
    //       ? "تحويلات نقدية"
    //       : row.type === "employee_withdrawal"
    //       ? "مسحوبات الموظفين"
    //       : "معاملة مالية",
    // },
    {
      header: "رقم الفاتورة",
      accessor: (row) => row.money_invoice?.invoice_number || "-",
    },
    { header: "قيمة العملية", accessor: "value" },
    { header: "الرصيد بعد العملية", accessor: "total_value" },
  ];

  const handleSearch = () => {
    if (!filters.cash_type) {
      toast.error("من فضلك اختر نوع الخزنة");
      return;
    }

    setAppliedFilters(filters);
    setRefreshKey((prev) => prev + 1);
  };
  const totalValue = (value) => {
    setCashBalance(value);
  };
  useEffect(() => {
    const today = new Date();

    // أول يوم في الشهر الحالي
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    // آخر يوم في الشهر الحالي
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    // نحول التاريخ إلى صيغة YYYY-MM-DD بدون UTC
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    setFilters({ ...filters, to: formatDate(lastDay), from: formatDate(firstDay) });
  }, []);

  return (
    <div className="container mt-5">
      <Mytitle title="تقرير الخزينة" />
      {cashBalance !== null && (
        <div
          className="alert alert-info text-end fw-bold"
          style={{ background: "" }}>
          الرصيد الحالي في{" "}
          {cashBalance?.cash_type === "bank" ? "البنك" : "الخزنه"} :{" "}
          <span className="text-success">
            {Math.trunc(cashBalance?.total_value)}
          </span>
        </div>
      )}
      <div className="row flex-row-reverse mb-3">
        <div className="col-md-2">
          <MyInput
            label="من"
            type="date"
            value={filters.from}
            onChange={(e) => setFilters({ ...filters, from: e.target.value })}
            dontShowDay={true}
          />
        </div>

        <div className="col-md-2">
          <MyInput
            label="إلى"
            type="date"
            value={filters.to}
            onChange={(e) => setFilters({ ...filters, to: e.target.value })}
            dontShowDay={true}
          />
        </div>
        <div className="col-md-2">
          <MyInput
            as="select"
            value={filters.cash_type}
            onChange={(e) =>
              setFilters({ ...filters, cash_type: e.target.value })
            }
            options={[
              { value: "", label: "إختر الخزنة" },
              { value: "cash", label: "كاش" },
              { value: "bank", label: "بنك" },
            ]}
          />
        </div>

        <div className="col-md-1 d-flex align-items-center">
          <MyButton onClick={handleSearch} text="بحث" />
        </div>
      </div>

      {appliedFilters && (
        <MyTable
          title="تقرير الخزينة"
          resource="cash-report"
          method="post"
          body={appliedFilters}
          columns={columns}
          refreshKey={refreshKey}
          cashBalance={cashBalance}
          setCashBalance={setCashBalance}
          totalValue={totalValue}
          button={{}}
          component="cash"
        />
      )}
    </div>
  );
}

export default Cash;
